import React from 'react';
import { Spin } from 'antd';
import { memo } from 'react';
import './styles.css';
/**
 * ローディング
 * @param {boolean} overFooter フッターまでローディングを出すかどうか。
 */
interface CenterLoadingProps {
    overFooter?: boolean;
}

const CenterLoading = memo(({ overFooter = false }: CenterLoadingProps) => {
    return (
        <div className={`loading ${overFooter && 'over-footer'}`}>
            <div className="loading-content">
                <Spin fullscreen={true} tip={'Loading'} className="loading-spin" />
            </div>
        </div>
    );
});

export default CenterLoading;
